import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function Footer() {
  /* ---------- State: son sürüm ---------- */
  const [latest, setLatest] = useState(null);

  /* ---------- İlk açılışta API çağrısı ---------- */
  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/versions`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const list = Array.isArray(data) ? data : data.data ?? [];
        if (list.length) {
          /* tarihe göre azalan sırala, ilkini al */
          const newest = [...list].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
          )[0];
          setLatest(newest);
        }
      } catch (err) {
        console.error("Footer – versiyon çekilemedi:", err);
      }
    })();
  }, []);

  /* ---------- Görünüm ---------- */
  return (
    <footer className="footer d-flex justify-content-between align-items-center">
      <p className="fs-11 text-muted fw-medium text-uppercase mb-0">
        COPYRIGHT © {new Date().getFullYear()}
      </p>

      {latest && (
        <Link
          to="/version/history"
          className="fs-11 text-primary fw-semibold text-uppercase mb-0"
          title={latest.title}
        >
          {latest.title}
        </Link>
      )}
    </footer>
  );
}
